"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getDefaultInsightEditMenuItems = void 0;
var tslib_1 = require("tslib");
// (C) 2021-2023 GoodData Corporation
var react_1 = tslib_1.__importDefault(require("react"));
var compact_1 = tslib_1.__importDefault(require("lodash/compact"));
var InsightConfiguration_1 = require("../../insight/configuration/InsightConfiguration");
var InsightInteractions_1 = require("../../insight/configuration/InsightInteractions");
var sdk_ui_kit_1 = require("@gooddata/sdk-ui-kit");
var model_1 = require("../../../../model");
/**
 * @internal
 */
function getDefaultInsightEditMenuItems(widget, _a) {
    var intl = _a.intl, dispatch = _a.dispatch, _b = _a.includeInteractions, includeInteractions = _b === void 0 ? true : _b;
    return compact_1.default([
        {
            type: "submenu",
            itemId: "ConfigurationPanelSubmenu",
            tooltip: "",
            itemName: intl.formatMessage({ id: "configurationPanel.title" }),
            icon: "gd-icon-settings",
            disabled: false,
            className: "s-configuration-panel-submenu",
            SubmenuComponent: InsightConfiguration_1.InsightConfiguration,
        },
        includeInteractions && {
            type: "submenu",
            itemId: "InteractionPanelSubmenu",
            tooltip: "",
            itemName: intl.formatMessage({ id: "configurationPanel.interactions" }),
            icon: react_1.default.createElement(sdk_ui_kit_1.Icon.Interaction, { className: "item-icon" }),
            disabled: false,
            className: "s-configuration-panel-submenu",
            SubmenuComponent: InsightInteractions_1.InsightInteractions,
        },
        {
            type: "separator",
            itemId: "InteractionPanelRemoveSeparator",
        },
        {
            type: "button",
            itemId: "InteractionPanelRemove",
            tooltip: "",
            itemName: intl.formatMessage({ id: "configurationPanel.remove.form.dashboard" }),
            icon: "gd-icon-trash",
            disabled: false,
            className: "s-delete-insight-item",
            onClick: function () { return dispatch(model_1.eagerRemoveSectionItemByWidgetRef(widget.ref)); },
        },
    ]);
}
exports.getDefaultInsightEditMenuItems = getDefaultInsightEditMenuItems;
//# sourceMappingURL=getDefaultInsightEditMenuItems.js.map